import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
  signIn: {
    id: 'inlineSignIn.signIn',
    defaultMessage: 'Sign In',
  },
  emailLabel: {
    id: 'inlineSignIn.emailLabel',
    defaultMessage: 'Your email',
  },
  emailHint: {
    id: 'inlineSignIn.emailHint',
    defaultMessage: 'For updates and confirmation.',
  },
  youHaveAnAccount: {
    id: 'inlineSignIn.youHaveAnAccount',
    defaultMessage: 'You already have an account.',
  },
  emailWasUsedWithFacebook: {
    id: 'inlineSignIn.emailWasUsedWithFacebook',
    defaultMessage: 'This email has been used with Facebook.',
  },
  emailBelongsToGuest: {
    id: 'inlineSignIn.emailBelongsToGuest',
    defaultMessage: 'This email belongs to a guest account.',
  },
  createPasswordLabel: {
    id: 'inlineSignIn.createPasswordLabel',
    defaultMessage: 'Create a password',
  },
  createPasswordHint: {
    id: 'inlineSignIn.createPasswordHint',
    defaultMessage: "Don't create an account, just pay."
  },
  continueWithFacebookLabel: {
    id: 'inlineSignIn.continueWithFacebookLabel',
    defaultMessage: 'Continue with Facebook',
  },
  continueWithFacebookHint: {
    id: 'inlineSignIn.continueWithFacebookHint',
    defaultMessage: 'You previously logged in with Facebook. Please click to authenticate again.',
  },
  magicLinkInstructions: {
    id: 'inlineSignIn.magicLinkInstructions',
    defaultMessage: 'You have a guest account. You must verify your email to continue.',
  },
  sendMeALink: {
    id: 'inlineSignIn.sendMeALink',
    defaultMessage: 'Send me a link to authenticate.',
  },
  enterPasswordLabel: {
    id: 'inlineSignIn.enterPasswordLabel',
    defaultMessage: 'Password',
  },
  enterPasswordHint: {
    id: 'inlineSignIn.enterPasswordHint',
    defaultMessage: 'Please login with your password.',
  },
  enterPasswordForgot: {
    id: 'inlineSignIn.enterPasswordForgot',
    defaultMessage: 'Forgot?',
  },
});



// WEBPACK FOOTER //
// ./src/desktop/pages/single-payer-payment/inline-sign-in.i18n.js